<template>
  <form novalidate class="md-layout" @submit.prevent="saveTravelInfo">
    <div class="md-layout-item md-size-33">
      <md-switch v-model="traveller.travel_info.terms_accepted"
        >Terms Accepted</md-switch
      >
    </div>
    <div class="md-layout-item md-size-66">
      <md-field>
        <label for="own_bike_details">Bike Details</label>
        <md-input
          name="own_bike_details"
          id="own_bike_details"
          v-model="traveller.travel_info.own_bike_details"
        />
      </md-field>
    </div>

    <div class="md-layout-item md-size-100">
      <div class="travel-block md-layout">
        <div class="md-layout-item md-size-100">
          <h6>Insurance</h6>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="insurance_company">Insurance Company</label>
            <md-input
              name="insurance_company"
              id="insurance_company"
              v-model="traveller.travel_info.insurance_company"
            />
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="insurance_policy">Insurance Policy Number</label>
            <md-input
              name="insurance_policy"
              id="insurance_policy"
              v-model="traveller.travel_info.insurance_policy"
            />
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="insurance_contact">Insurance Contact</label>
            <md-input
              name="insurance_contact"
              id="insurance_contact"
              v-model="traveller.travel_info.insurance_contact"
            />
          </md-field>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <div class="travel-block md-layout">
        <div class="md-layout-item md-size-100">
          <h6>Arrival Details</h6>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker
            v-model="traveller.travel_info.arrival_date"
            md-immediately
            :md-model-type="String"
            :md-open-on-focus="false"
          >
            <label>Arrival Date [YYYY-MM-DD]</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>Arrival Time</label>
            <md-input
              v-model="traveller.travel_info.arrival_time"
              type="time"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label for="arrival_transport">Transport Mode</label>
            <md-select
              v-model="traveller.travel_info.arrival_transport"
              md-dense
              name="arrival_transport"
              id="arrival_transport"
            >
              <md-option
                v-for="(key, mode) in transportModes"
                :key="key"
                :value="key"
              >
                {{ mode }}
              </md-option>
            </md-select>
          </md-field>
        </div>

        <template
          v-if="this.traveller.travel_info.arrival_transport == 'train'"
        >
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="arrival_train_station">Arrival Train Station</label>
              <md-input
                name="arrival_train_station"
                id="arrival_train_station"
                v-model="traveller.travel_info.arrival_train_station"
              />
            </md-field>
          </div>
        </template>

        <template
          v-if="this.traveller.travel_info.arrival_transport == 'flight'"
        >
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="arrival_airport">Arrival Airport</label>
              <md-input
                name="arrival_airport"
                id="arrival_airport"
                v-model="traveller.travel_info.arrival_airport"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="arrival_flight_number">Flight Number</label>
              <md-input
                name="arrival_flight_number"
                id="arrival_flight_number"
                v-model="traveller.travel_info.arrival_flight_number"
              />
            </md-field>
          </div>
        </template>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Pre-Trip Accommodation</label>
            <md-textarea
              id="arrival"
              name="arrival"
              v-model="traveller.travel_info.arrival_accommodation"
              md-autogrow
            ></md-textarea>
          </md-field>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <div class="travel-block md-layout">
        <div class="md-layout-item md-size-100">
          <h6>Departure Details</h6>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker
            v-model="traveller.travel_info.departure_date"
            md-immediately
            :md-model-type="String"
            :md-open-on-focus="false"
          >
            <label>Departure Date</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>Departure Time</label>
            <md-input
              v-model="traveller.travel_info.departure_time"
              type="time"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label for="arrival_transport">Transport Mode</label>
            <md-select
              v-model="traveller.travel_info.departure_transport"
              md-dense
              name="departure_transport"
              id="departure_transport"
            >
              <md-option
                v-for="(key, mode) in transportModes"
                :key="key"
                :value="key"
              >
                {{ mode }}
              </md-option>
            </md-select>
          </md-field>
        </div>

        <template
          v-if="this.traveller.travel_info.departure_transport == 'train'"
        >
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="departure_train_station"
                >Departure Train Station</label
              >
              <md-input
                name="departure_train_station"
                id="departure_train_station"
                v-model="traveller.travel_info.departure_train_station"
              />
            </md-field>
          </div>
        </template>

        <template
          v-if="this.traveller.travel_info.departure_transport == 'flight'"
        >
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="departure_airport">Departure Airport</label>
              <md-input
                name="departure_airport"
                id="departure_airport"
                v-model="traveller.travel_info.departure_airport"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="departure_flight_number">Flight Number</label>
              <md-input
                name="departure_flight_number"
                id="departure_flight_number"
                v-model="traveller.travel_info.departure_flight_number"
              />
            </md-field>
          </div>
        </template>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Post-Trip Accommodation</label>
            <md-textarea
              id="departure_accommodation"
              name="departure_accommodation"
              v-model="traveller.travel_info.departure_accommodation"
              md-autogrow
            ></md-textarea>
          </md-field>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100 text-right">
      <md-button type="submit" class="md-success md-dense" :disabled="sending"
        >Save</md-button
      >
    </div>
  </form>
</template>

<script>
import bookingApi from "@/services/api/booking";
import _filter from "lodash/filter";

export default {
  name: "BookingTravellerTravelInfo",

  props: ["traveller", "booking", "transportModes"],

  data() {
    return {
      sending: false
    };
  },

  components: {},

  computed: {},

  created() {},

  methods: {
    saveTravelInfo() {
      bookingApi
        .updateTravelInfo(this.booking, this.traveller)
        .then(response => {
          this.traveller.travel_info.id = response.data.travel_info.id;

          this.$notify({
            timeout: 2500,
            message: "Travel Info Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
.travel-block {
  padding: 10px;
  border: 1px solid $brand-primary;
  margin-bottom: 1rem;
  border-radius: 5px;

  h6 {
    margin: 0;
  }
}
</style>
